//--- React
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Radio, Row } from "antd";
//--- Project
import { TEST_RIDE_SUMMARY } from "components/Common/Grafana/Constants";
import GetIframe from "components/Common/Grafana/GetIframe";
import panelList from "./panelList.json";

const Routes = ({ baseUrl, baseFilterObject }) => {
  const tripSummary = useSelector((state) => state.testRide.tripSummary);
  const [geo, setGeo] = useState(panelList?.geo?.[0]?.var_name);

  useMemo(() => {
    setGeo(panelList?.geo?.[0]?.var_name);

    // eslint-disable-next-line
  }, [tripSummary]);

  const onSelectGeo = (selectedValues) => {
    setGeo(selectedValues);
  };

  const driveModeVariable = () => {
    const modeList = TEST_RIDE_SUMMARY?.DRIVE_MODE_VARIABLES?.map(
      (mode, index) => ({
        [mode]: tripSummary?.tripModeStats?.[index]?.mode || "",
      })
    );
    return Object.assign(baseFilterObject, ...modeList);
  };

  return (
    <Row gutter={[16, 16]} className="routes">
      <Col sm={24} md={6} lg={6} className="mt1">
        <Radio.Group
          onChange={(e) => onSelectGeo(e.target.value)}
          className="routes-tab-filter"
          value={geo || panelList?.geo?.[0]?.var_name}
          options={panelList?.geo?.map((i) => ({
            label: i.title,
            value: i.var_name,
          }))}
        />
      </Col>
      <Col sm={24} md={18} lg={18} id="geo" className="mt1">
        <GetIframe
          title="Geo"
          url={baseUrl}
          panelId={TEST_RIDE_SUMMARY.PANEL_ID?.geo?.[geo]}
          variableObject={
            geo === "locDriveMode" ? driveModeVariable() : baseFilterObject
          }
          variableKeys={
            geo === "locDriveMode"
              ? [
                  ...TEST_RIDE_SUMMARY?.BASE_VARIABLES,
                  ...TEST_RIDE_SUMMARY?.DRIVE_MODE_VARIABLES,
                ]
              : TEST_RIDE_SUMMARY.BASE_VARIABLES
          }
          width="100%"
          height="352"
          divId="geo"
        />
      </Col>
    </Row>
  );
};

export default Routes;
